import * as XLSX from 'xlsx';

export const dataToWorkbook = (data: object[]) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  return workbook;
};

export const downloadSpreadsheet = (data: object[], fileName: string, format: 'csv' | 'xlsx' = 'csv') => {
  const workbook = dataToWorkbook(data);
  XLSX.writeFile(workbook, `${fileName}.${format}`, { type: 'file' });
};
